import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PlusOutlined } from '@ant-design/icons';
import { translate } from '@smovilgps/optimus-intl';
import { Button } from 'antd';
import PropTypes from 'prop-types';

const AddButton = ({ setModalVisibility }) => {
	return (
		<Button className="editable-add-btn" type="primary" onClick={() => setModalVisibility()} data-testid="btn-add">
			<PlusOutlined />
			<FormattedMessage {...translate('add')} />
		</Button>
	);
};

AddButton.propTypes = {
	setModalVisibility: PropTypes.func.isRequired,
};

export default AddButton;
